import { css } from '@emotion/react';
import { MEDIA_MIN_MD } from '_assets/css/breakpoints';

export const buttonsContainer = css`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${MEDIA_MIN_MD} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 8px;
  }
`;
